import { useTranslation } from 'react-i18next'

import { InputField } from '../fields/input-field'

type Props = {
  form: any
  showNameField?: boolean
}

export const ContactDetailsForm = ({ form, showNameField = true }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <InputField
        control={form.control}
        type="email"
        name="contact.email"
        label={t('email_address')}
        placeholder="E.g. you@email.com"
      />
      {showNameField && (
        <InputField
          control={form.control}
          type="text"
          name="contact.name"
          label={t('name_optional')}
          placeholder="E.g. John Doe"
        />
      )}
    </>
  )
}
